import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeasurePipe } from './measure/measure.pipe';

@NgModule({
  declarations: [
    MeasurePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MeasurePipe
  ]
})
export class PipesModule { }
